import React from 'react';
import { motion } from 'framer-motion';
const KIT_URL = 'https://digital-solvex-ar.myshopify.com/cart/48681186394369:1';
const products = [{
  img: 'https://cdn.shopify.com/s/files/1/0815/5253/9905/files/IMAGEN_1_Sistema_ML_Rentable_1_1.jpg?v=1777410950',
  name: 'Sistema ML Rentable',
  tagline: 'Calculadora de rentabilidad + Simulador de precios + Dashboard',
  oldPrice: '$79.900',
  newPrice: '$34.900',
  discount: '57% OFF',
  url: 'https://digital-solvex-ar.myshopify.com/cart/48681189736705:1'
}, {
  img: 'https://cdn.shopify.com/s/files/1/0815/5253/9905/files/IMAGEN_2_Tracker_de_Stock_e_Inventario_1_1.jpg?v=1777410949',
  name: 'Tracker de Stock ML',
  tagline: 'Semáforo de stock · Capital invertido · Alertas de reposición',
  oldPrice: '$49.900',
  newPrice: '$24.900',
  discount: '50% OFF',
  url: 'https://digital-solvex-ar.myshopify.com/cart/48681636430081:1'
}, {
  img: 'https://cdn.shopify.com/s/files/1/0815/5253/9905/files/IMAGEN_3_Sistema_de_Escalado_90_Dias_1_1.jpg?v=1777410950',
  name: 'Sistema Escalado 90 Días',
  tagline: 'Proyección de crecimiento · Plan semanal · Selector de productos',
  oldPrice: '$89.900',
  newPrice: '$39.900',
  discount: '56% OFF',
  url: 'https://digital-solvex-ar.myshopify.com/cart/48681650520321:1'
}];
export function IndividualProducts() {
  return <section className="bg-cream py-16 md:py-24" data-id="element-139">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-140">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-141">
          <h2 className="font-display font-extrabold text-3xl md:text-4xl lg:text-5xl text-navy mb-4" data-id="element-142">
            ¿Preferís empezar con un solo producto?
          </h2>
          <p className="text-navy/50 text-lg max-w-2xl mx-auto" data-id="element-143">
            El Kit es siempre la mejor opción, pero estos productos también
            están disponibles por separado.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-6 mb-10" data-id="element-144">
          {products.map((product, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-white rounded-2xl shadow-lg overflow-hidden border border-navy/5 flex flex-col" data-id="element-145">
              {/* Imagen real */}
              <div className="relative w-full" style={{
            aspectRatio: '1/1',
            overflow: 'hidden'
          }} data-id="element-146">
                <img src={product.img} alt={product.name} style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              display: 'block'
            }} data-id="element-147" />
                <div className="absolute top-3 right-3 bg-red-500 text-white text-xs font-extrabold px-2.5 py-1 rounded-full" data-id="element-148">
                  {product.discount}
                </div>
              </div>

              <div className="p-6 flex flex-col flex-grow" data-id="element-149">
                <h3 className="font-display font-bold text-navy text-lg mb-1" data-id="element-150">{product.name}</h3>
                <p className="text-navy/45 text-sm mb-4 flex-grow" data-id="element-151">{product.tagline}</p>

                <div className="flex items-baseline gap-3 mb-5" data-id="element-152">
                  <span className="text-navy/30 line-through text-sm" data-id="element-153">{product.oldPrice}</span>
                  <span className="font-display font-extrabold text-navy text-2xl" data-id="element-154">{product.newPrice}</span>
                </div>

                <a href={product.url} className="btn-gold block w-full text-center py-3 rounded-xl font-extrabold text-sm no-underline" data-id="element-155">
                  Comprar ahora →
                </a>
              </div>
            </motion.div>)}
        </div>

        {/* Kit Upsell Banner */}
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-navy rounded-2xl p-8 md:p-10 flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-156">
          <div data-id="element-157">
            <h3 className="font-display font-bold text-white text-2xl md:text-3xl mb-1" data-id="element-158">
              ¿O llevate el sistema completo por{' '}
              <span className="text-gold" data-id="element-159">$62.900</span>?
            </h3>
            <p className="text-white/50" data-id="element-160">
              Ahorrás $71.600 vs comprarlos por separado. Acceso inmediato a todo.
            </p>
          </div>
          <a href={KIT_URL} className="btn-gold flex-shrink-0 inline-block px-10 py-3.5 rounded-xl font-extrabold whitespace-nowrap no-underline" data-id="element-161">
            Ver Kit Completo →
          </a>
        </motion.div>
      </div>
    </section>;
}